import map from 'lodash/map'
import React, { FC, useContext } from 'react'

import { SliderContext } from '@Components/Product/Slider/Context/SliderContext'

import styles from './SliderProgress.module.scss'

const SliderProgress: FC = () => {
  const {
    activeSlide,
    isFullscreen,
    slides,
  } = useContext(SliderContext)

  if (slides.length === 1) {
    return null
  }

  return (
    <div className={`${styles.progress} ${isFullscreen ? styles.fullscreen : ''}`}>
      {map(slides, (slide, key) => (
        <div
          key={`progress-${key}`}
          className={`${styles.progressItem} ${activeSlide.key === key ? styles.active : ''}`}
        />
      ))}
    </div>
  )
}

export default SliderProgress
